import axios from '@_system/axios/axios.js'
export default {
	path: '/dingtalk',
	login(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/login', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
}
